// Shared loading state (#139) — a polite, screen-reader-announced status line.
// Replaces each screen's hand-rolled loading markup so "loading" looks and
// announces the same everywhere, and is always distinguishable from an empty
// account (EmptyState) and a failure (ErrorState).

export interface LoadingProps {
  /** What's loading, e.g. "Loading your gallery…". */
  label?: string;
}

export function Loading({ label = "Loading…" }: LoadingProps): React.JSX.Element {
  return (
    <div className="status" role="status" aria-live="polite" data-testid="loading">
      {label}
    </div>
  );
}
